import Vue from "vue";
import VueRouter from "vue-router";

import Login from "@/views/Authentication/Login/Login";
import Register from "@/views/Authentication/Register/Register";
import EmailVerification from "@/views/Authentication/EmailVerification/EmailVerification";
import ForgotPassword from "@/views/Authentication/ForgotPassword/ForgotPasswordWithPhone";
import ResetPassword from "@/views/Authentication/ResetPassword/ResetPassword";
import MainApp from "@/containers/App/MainApp";
import NotFound from "@/views/NotFound/NotFound.vue";
import Admin from "../views/Admin/Admin.vue";
// import store from "../store";
// import {
//   GET_AUTH_DATA,
//   IS_TOKEN_ALIVE,
//   SIGNIN_USER_SUCCESS
// } from "../store/mutation-types";
// import { refreshAllToken } from "../services/auth";
// import { tokenAlive } from "../utils/jwtHelper";
import { verifyToken } from "../services/auth";

Vue.use(VueRouter);

const routes = [
  // login
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { authRequired: false }
  },
  // Register
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { authRequired: false }
  },
  // Email verivication
  {
    path: "/email-verification/:token",
    name: "EmailVerification",
    component: EmailVerification,
    meta: { authRequired: false }
  },
  // Forget Password
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { authRequired: false }
  },
  // Reset Password
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { authRequired: false }
  },
  //other path
  {
    beforeEnter: async (to, from, next) => {
      const token = localStorage.getItem("auth_access");
      if (token == null) {
        next({
          path: "/login",
          query: {
            return_to: to.fullPath
          }
        });
      } else {
        const [error, data] = await verifyToken({
          token: token
        });
        if (error) {
          localStorage.removeItem("auth_access");
          localStorage.removeItem("auth_refresh");
          next({
            path: "/login",
            query: {
              return_to: to.fullPath
            }
          });
        } else {
          if (data.apiStatus === 200) {
            next();
          } else {
            localStorage.removeItem("auth_access");
            localStorage.removeItem("auth_refresh");
            next({
              path: "/login",
              query: {
                return_to: to.fullPath
              }
            });
          }
        }
      }
    },
    path: "/",
    name: "MainApp",
    component: MainApp,
    redirect: "/app/list",
    children: [
      /***********ADMIN*********/
      {
        beforeEnter: async (to, from, next) => {
          const token = localStorage.getItem("auth_access");
          if (token == null) {
            next({
              path: "/login",
              query: {
                return_to: to.fullPath
              }
            });
          } else {
            const [error, data] = await verifyToken({
              token: token
            });
            if (error) {
              next({ path: "/" });
            } else {
              if (data.apiStatus === 200) {
                if (data.apiData.roleId === 2) {
                  next();
                } else {
                  next({ path: "/" });
                }
              } else {
                next({ path: "/" });
              }
            }
          }
        },
        path: "/admin",
        name: "Admin",
        redirect: "/admin/dashboard",
        component: Admin,
        children: [
          //Admin dashboard
          {
            path: "dashboard",
            name: "AdminDashboard",
            component: () =>
              import(
                /* webpackChunkName: "adminDashboard" */ "../views/Admin/Dashboard/Dashboard.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          // Admin User
          {
            path: "user",
            name: "AdminUser",
            component: () =>
              import(
                /* webpackChunkName: "adminUser" */ "../views/Admin/User/User.vue"
              ),
            children: [
              //Admin User List
              {
                path: "list",
                name: "AdminUserList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminUser" */ "../views/Admin/User/List/UserList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              },
              //Admin User Details
              {
                path: ":userId/details",
                name: "AdminUserDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "adminUser" */ "../views/Admin/User/Details/UserDetails.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              },
              //Admin User edit
              {
                path: ":userId/edit",
                name: "AdminUserEdit",
                component: () =>
                  import(
                    /* webpackChunkName: "adminUser" */ "../views/Admin/User/Edit/UserEdit.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
              //Admin User change Password
              // {
              //   path: ":userId/change-password",
              //   name: "AdminUserChangePassword",
              //   component: () =>
              //     import(
              //       /* webpackChunkName: "adminUser" */ "../views/Admin/User/ChangePassword/UserChangePassword.vue"
              //     ),
              //   meta: { menu: "mainMenu", authRequired: true }
              // }
            ]
          },
          // Admin Apps
          {
            path: "apps",
            name: "AdminDatabase",
            redirect: "/apps/list",
            component: () =>
              import(
                /* webpackChunkName: "adminUserServices" */ "../views/Admin/App/App.vue"
              ),
            children: [
              //Admin App List
              {
                path: "list",
                name: "AdminAppsList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminApp" */ "../views/Admin/App/List/AppsList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              },
              //Admin App Details
              {
                path: ":serviceId/details",
                name: "AdminAppDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "adminApp" */ "../views/Admin/App/Details/AppDetails.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          },
          // Admin Databases
          {
            path: "databases",
            name: "AdminDatabase",
            redirect: "/databases/list",
            component: () =>
              import(
                /* webpackChunkName: "adminDatabase" */ "../views/Admin/Database/Database.vue"
              ),
            children: [
              //Admin Database List
              {
                path: "list",
                name: "AdminDatabasesList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminDatabase" */ "../views/Admin/Database/List/DatabasesList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              },
              //Admin Database Details
              {
                path: ":serviceId/details",
                name: "AdminDatabasesDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "adminDatabase" */ "../views/Admin/Database/Details/DatabaseDetails.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          },
          // Admin Domain
          {
            path: "domain",
            name: "AdminDomain",
            redirect: "/domain/list",
            component: () =>
              import(
                /* webpackChunkName: "adminDomain" */ "../views/Admin/Domain/Domain.vue"
              ),
            children: [
              //Admin Domain List
              {
                path: "list",
                name: "AdminDomainList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminDomain" */ "../views/Admin/Domain/List/DomainList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          },
          // Admin Payment
          {
            path: "payment",
            name: "AdminPayment",
            redirect: "/payment/list",
            component: () =>
              import(
                /* webpackChunkName: "adminPayment" */ "../views/Admin/Payment/Payment.vue"
              ),
            children: [
              //Admin Payment List
              {
                path: "list",
                name: "AdminPaymentList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminPayment" */ "../views/Admin/Payment/List/PaymentList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          },
          //admin Ticket
          {
            path: "ticket",
            name: "AdminTicket",
            redirect: "/ticket/list",
            component: () =>
              import(
                /* webpackChunkName: "adminTicket" */ "../views/Admin/Ticket/Ticket.vue"
              ),
            children: [
              //Admin Ticket List
              {
                path: "list",
                name: "AdminTicketList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminTicket" */ "../views/Admin/Ticket/List/TicketList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              },
              //Admin Ticket Details
              {
                path: ":ticketId/details",
                name: "AdminTicketDetails",
                component: () =>
                  import(
                    /* webpackChunkName: "adminTicket" */ "../views/Admin/Ticket/Details/TicketDetails.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          },
          //Admin Resource
          {
            path: "resources",
            name: "AdminResources",
            redirect: "/resources/list",
            component: () =>
              import(
                /* webpackChunkName: "adminResources" */ "../views/Admin/Resources/Resources.vue"
              ),
            children: [
              //Admin Resources List
              {
                path: "list",
                name: "AdminResourcesList",
                component: () =>
                  import(
                    /* webpackChunkName: "adminResources" */ "../views/Admin/Resources/List/ResourcesList.vue"
                  ),
                meta: { menu: "mainMenu", authRequired: true }
              }
            ]
          }
        ]
      },
      /***********USER*********/
      // apps
      {
        path: "/app",
        name: "App",
        redirect: "/app/list",
        component: () =>
          import(/* webpackChunkName: "apps" */ "../views/App/App.vue"),
        children: [
          //app list
          {
            path: "list",
            name: "AppList",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/List/AppList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //app create
          {
            path: "create",
            name: "AppCreate",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Create/AppCreate.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //app details
          {
            path: ":serviceId/details",
            name: "AppDetails",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Details/AppDetails.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app ftp
          {
            path: ":serviceId/ftp",
            name: "AppFTP",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/FTP/AppFTP.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app fileManager
          {
            path: ":serviceId/filemanager",
            name: "AppFileManager",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/FileManager/AppFileManager.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app backup
          {
            path: ":serviceId/backup",
            name: "AppBackup",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Backup/AppBackup.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app monitoring
          {
            path: ":serviceId/monitoring",
            name: "AppMonitoring",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Monitoring/AppMonitoring.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app logs
          {
            path: ":serviceId/logs",
            name: "AppLogs",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Logs/AppLogs.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app console
          {
            path: ":serviceId/console",
            name: "AppConsole",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Console/AppConsole.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app resize
          {
            path: ":serviceId/resize",
            name: "AppResize",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Resize/AppResize.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          },
          //app setting
          {
            path: ":serviceId/settings",
            name: "AppSettings",
            component: () =>
              import(
                /* webpackChunkName: "apps" */ "../views/App/Settings/AppSettings.vue"
              ),
            meta: { menu: "appMenu", authRequired: true }
          }
        ]
      },
      // databases
      {
        path: "/database",
        name: "Database",
        redirect: "/database/list",
        component: () =>
          import(
            /* webpackChunkName: "Databases" */ "../views/Database/Database.vue"
          ),
        children: [
          //db list
          {
            path: "list",
            name: "DatabaseList",
            component: () =>
              import(
                /* webpackChunkName: "Databases" */ "../views/Database/List/DatabaseList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //db create
          {
            path: "create",
            name: "DatabaseCreate",
            component: () =>
              import(
                /* webpackChunkName: "Databases" */ "../views/Database/Create/DatabaseCreate.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //db backup
          {
            path: ":serviceId/backup",
            name: "DatabaseBackup",
            component: () =>
              import(
                /* webpackChunkName: "Databases" */ "../views/Database/Backup/DatabaseBackup.vue"
              ),
            meta: { menu: "dbMenu", authRequired: true }
          },
          //db details
          {
            path: ":serviceId/details",
            name: "DatabaseDetails",
            component: () =>
              import(
                /* webpackChunkName: "Databases" */ "../views/Database/Details/DatabaseDetails.vue"
              ),
            meta: { menu: "dbMenu", authRequired: true }
          },
          //db resize
          {
            path: ":serviceId/resize",
            name: "DatabaseResize",
            component: () =>
              import(
                /* webpackChunkName: "Databases" */ "../views/Database/Resize/DatabaseResize.vue"
              ),
            meta: { menu: "dbMenu", authRequired: true }
          }
        ]
      },
      //stickets
      {
        path: "/ticket",
        name: "Ticket",
        component: () =>
          import(
            /* webpackChunkName: "tickets" */ "../views/Ticket/Ticket.vue"
          ),
        redirect: "/ticket/list",
        children: [
          //ticket list
          {
            path: "list",
            name: "TicketList",
            component: () =>
              import(
                /* webpackChunkName: "tickets" */ "../views/Ticket/List/TicketList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //ticket create
          {
            path: "create",
            name: "TicketCreate",
            component: () =>
              import(
                /* webpackChunkName: "tickets" */ "../views/Ticket/Create/TicketCreate.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //ticket details
          {
            path: ":ticketId/details",
            name: "TicketDetails",
            component: () =>
              import(
                /* webpackChunkName: "tickets" */ "../views/Ticket/Details/TicketDetails.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          }
        ]
      },
      // users
      {
        path: "/user",
        name: "User",
        redirect: "/user/profile",
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/User/User.vue"),
        children: [
          //user profile
          {
            path: "profile",
            name: "UserProfile",
            meta: { menu: "mainMenu", authRequired: true },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/User/Profile/Profile.vue"
              )
          },
          //user edit
          {
            path: "edit",
            name: "UserEdit",
            meta: { menu: "mainMenu", authRequired: true },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/User/Edit/Edit.vue"
              )
          },
          //user change password
          {
            path: "change-password",
            name: "UserChangePassword",
            meta: { menu: "mainMenu", authRequired: true },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/User/ChangePassword/ChangePassword.vue"
              )
          }
        ]
      },
      // payments
      {
        path: "/payment",
        name: "Payment",
        redirect: "/payment/list",
        component: () =>
          import(
            /* webpackChunkName: "payment" */ "../views/Payment/Payment.vue"
          ),
        children: [
          //payment list
          {
            path: "list",
            name: "PaymentList",
            component: () =>
              import(
                /* webpackChunkName: "payment" */ "../views/Payment/List/PaymentList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //payment add
          {
            path: "add",
            name: "PaymentAdd",
            component: () =>
              import(
                /* webpackChunkName: "payment" */ "../views/Payment/Add/PaymentAdd.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //payment verify
          {
            path: "verify",
            name: "PaymentVerify",
            component: () =>
              import(
                /* webpackChunkName: "payment" */ "../views/Payment/Verify/PaymentVerify.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          }
        ]
      },
      // backups
      {
        path: "/backup",
        name: "Backup",
        redirect: "/backup/list",
        component: () =>
          import(
            /* webpackChunkName: "payment" */ "../views/Backup/Backup.vue"
          ),
        children: [
          //backup list
          {
            path: "list",
            name: "BackupList",
            component: () =>
              import(
                /* webpackChunkName: "backup" */ "../views/Backup/List/BackupList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          }
        ]
      },
      // domains
      {
        path: "/domain",
        name: "Domain",
        redirect: "/domain/list",
        component: () =>
          import(
            /* webpackChunkName: "Domains" */ "../views/Domain/Domain.vue"
          ),
        children: [
          // domain list
          {
            path: "list",
            name: "DomainList",
            component: () =>
              import(
                /* webpackChunkName: "Domains" */ "../views/Domain/List/DomainList.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          },
          //domain details
          {
            path: ":domainId/details",
            name: "DomainDetails",
            component: () =>
              import(
                /* webpackChunkName: "Domains" */ "../views/Domain/Details/DomainDetails.vue"
              ),
            meta: { menu: "mainMenu", authRequired: true }
          }
        ]
      }
    ]
  },
  // page not found
  {
    path: "*",
    component: NotFound,
    meta: { menu: "mainMenu", authRequired: false }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// router.beforeEach(async (to, from, next) => {
//   ;
//   const authData = store.getters["auth/" + GET_AUTH_DATA];
//   ;
//   if (!authData.authAccessToken) {
//     const accessToken = localStorage.getItem("auth_access");
//     const refreshToken = localStorage.getItem("auth_refresh");
//     const expiresIn = localStorage.getItem("expiresIn");
//     if (accessToken) {
//       const data = { accessToken, refreshToken, expiresIn };
//       store.commit("auth/" + SIGNIN_USER_SUCCESS, data);
//     }
//     ;
//   }
//   let isAuthenticated = tokenAlive(authData.expiresIn);
//   ;
//   if (!isAuthenticated) {
//     const authData = store.getters["auth/" + GET_AUTH_DATA];
//     if (authData.authAccessToken) {
//       const [error, data] = await refreshAllToken({
//         accessToken: authData.authAccessToken,
//         refreshToken: authData.authRefreshToken
//       });
//       if (!error && data.apiStatus === 200) {
//         store.commit("auth/" + SIGNIN_USER_SUCCESS, data.apiData);
//         isAuthenticated = store.getters["auth/" + IS_TOKEN_ALIVE];
//       }
//       ;
//     }
//   }
//   if (isAuthenticated && !to.meta.authRequired) {
//     return next({ path: "/app/list" });
//   } else if (!isAuthenticated && to.meta.authRequired) {
//     return next({
//       path: "/login",
//       query: {
//         return_to: to.fullPath
//       }
//     });
//   }
//   return next();
// });

export default router;
